import React from 'react';
import PropTypes from 'prop-types';
import Tippy from '@tippyjs/react';
import TicketsToBreakevenTooltip from '../TicketsToBreakevenTooltip';
import { hasBreakevenColumn, breakevenCountLabel } from '../../utils/breakevenDisplay';

// Tickets-to-Breakeven rail card. Replicates the legacy offer-editor card —
// breakeven count "as offered" / "as forecasted" plus an info rollover that
// explains the calculation — restyled to match the Setlist design system.
// The rollover itself is shared with the advanced editor's deal-terms readout.
const SimpleTicketsToBreakevenCard = ({ ctrl }) => {
  const { calculated } = ctrl;
  const offeredDetail = calculated?.artistEarnings?.ticketsToBreakevenDetail;
  const forecastDetail = calculated?.artistEarningsForecast?.ticketsToBreakevenDetail;

  const hasOffered = hasBreakevenColumn(offeredDetail);
  const hasForecast = hasBreakevenColumn(forecastDetail);
  const count = (n) => Number(n || 0).toLocaleString();

  const tooltip = (
    <TicketsToBreakevenTooltip offeredDetail={offeredDetail} forecastDetail={forecastDetail} />
  );

  return (
    <div className="simple-offer-card simple-breakeven">
      <div className="simple-offer-card__eyebrow simple-breakeven__eyebrow">
        TICKETS TO BREAKEVEN
        {hasOffered && (
          <Tippy content={tooltip} placement="top" animation="shift-away" theme="material" maxWidth={390}>
            <button type="button" className="simple-breakeven__info" aria-label="How is this calculated?">
              <i className="fas fa-info-circle" aria-hidden="true" />
            </button>
          </Tippy>
        )}
      </div>

      <div className="simple-breakeven__primary">
        <span className="simple-breakeven__value">{breakevenCountLabel(offeredDetail)}</span>
        <span className="simple-breakeven__caption">as offered</span>
      </div>

      {hasForecast && (
        <div className="simple-breakeven__secondary">
          <span className="simple-breakeven__value simple-breakeven__value--sm">
            {breakevenCountLabel(forecastDetail)}
          </span>
          <span className="simple-breakeven__caption">as forecasted</span>
        </div>
      )}

      {offeredDetail?.beyondPlannedTickets && (
        <div className="simple-breakeven__note">
          more than the {count(offeredDetail?.totalTickets)} planned
        </div>
      )}
    </div>
  );
};

SimpleTicketsToBreakevenCard.propTypes = {
  ctrl: PropTypes.shape({
    calculated: PropTypes.object,
  }).isRequired,
};

export default SimpleTicketsToBreakevenCard;
